module.exports = __webpack_public_path__ + "img/4.20e247a4.png";